// web3Onboard.ts
import { init } from '@web3-onboard/react'
import injectedModule from '@web3-onboard/injected-wallets'
import walletConnectModule from '@web3-onboard/walletconnect'
import { mainNetwork, metadata } from '@/components/Context'
import { projectId } from '@/app/crazy/config'

let walletModulesInstance: any[] | null = null

export function getWalletModules() {
    if (!walletModulesInstance) {
        const injected = injectedModule()
        const walletConnect = walletConnectModule({
            projectId: projectId,
            dappUrl: metadata.url,
            requiredChains: [mainNetwork.chainId],
        })
        walletModulesInstance = [injected, walletConnect]
    }
    return walletModulesInstance
}

const chains = [
    {
        id: 31337,
        token: 'ETH',
        label: 'Hardhat',
        rpcUrl: `http://127.0.0.1:8545`,
    },
    {
        id: mainNetwork.chainId,
        token: mainNetwork.currency,
        label: mainNetwork.name,
        rpcUrl: mainNetwork.rpcUrl,
    },
]

const appMetadata = {
    name: 'Connect With Wallet',
    icon: '<svg>My App Icon</svg>',
    description: 'Connect a wallet.',
    recommendedInjectedWallets: [{ name: 'MetaMask', url: 'https://metamask.io' }],
}

let web3OnboardInstance: ReturnType<typeof init> | null = null

export function getWeb3Onboard() {
    if (!web3OnboardInstance) {
        web3OnboardInstance = init({
            chains,
            wallets: getWalletModules(),
            connect: { autoConnectLastWallet: false, autoConnectAllPreviousWallet: false },
            accountCenter: { desktop: { enabled: false }, mobile: { enabled: false } },
            theme: 'dark',
            appMetadata,
        })
    }
    return web3OnboardInstance
}
